<template>
  <div>
    <div :style="{height:imgWidth*0.262 + 'px',width:imgWidth}">
      <div class="imgTitle">电测 计量 检定 校验</div>
      <img style="width:100%;height:100%;" v-for="item in img" :key="item.id" :src="item.image" alt />
    </div>
    <div id="main">
      <div class="main_title">
        <div class="line"></div>
        <div style="font-family:SimHei;">
          走进新海通
          >>>
          <router-link to="/walkintoXinhaitong">企业简介</router-link>>
          <span style="color:#3f33c0;">历史沿革</span>
          >
          <router-link to="/intellectualPropertyandPatent">知识产权及专利</router-link>>
          <router-link to="/totalQualityManagement">全面质量管理</router-link>
          <!-- <span style="margin-left:40px;">ENTER XINHAITONG</span> -->
          <router-link to="/">
            <img class="back_to_index" src="../../assets/images/back_to_index.png" alt />
            <!-- <el-image
              class="back_to_index"
              src="../../assets/images/back_to_index.png"
              alt
              fit="scale-down"
            ></el-image>-->
          </router-link>
        </div>
      </div>

      <div v-html="data_info.content" style="margin-bottom:40px;"></div>

      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in imgs" :key="index">
            <div>
              <img class="img" :src="item.image" alt />
              <!-- <el-image class="img" :src="item.image" alt fit="scale-down"></el-image> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
export default {
  data: function () {
    return {
      imgs: [],
      data_info: "",
      img: [],
      imgWidth: "",
    };
  },
  created: function () {
    this.$fetch("Aboutus/historyInfo").then((res) => {
      if (res.code == 1) {
        // console.log(111, res);
        this.data_info = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    }); // 获取头图数据
    this.$fetch("index/getAdList", { slot_id: 2 }).then((res) => {
      if (res.code == 1) {
        // console.log(res);
        this.img = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
    this.imgWidth = document.body.clientWidth;
    setTimeout(function () {
      $(".imgTitle").css({ transform: "scale(1)", transition: "2s" });
    }, 1000);
    setTimeout(function () {
      $(".imgTitle").css({ transform: "scale(0)", transition: "2s" });
    }, 3000);
    setInterval(() => {
      setTimeout(function () {
        $(".imgTitle").css({ transform: "scale(1)", transition: "2s" });
      }, 1000);
      setTimeout(function () {
        $(".imgTitle").css({ transform: "scale(0)", transition: "2s" });
      }, 3000);
    }, 5000);

    // 获取轮播图数据
    this.$fetch("index/getBottomPic", { cate_id: 3 }).then((res) => {
      if (res.code == 1) {
        // console.log(res);
        this.imgs = res.data;
      } else {
        alert("请求出错，请稍后再试");
      }
    });
  },
  updated: function () {
    var mySwiper = new Swiper(".swiper-container", {
      loop: true,
      autoplay: 3000,
      speed: 500,
      slidesPerView: "auto",
      observer: true,
      observeParents: true,
    });
  },
};
</script>
<style scoped>
.imgTitle {
  position: absolute;
  color: #0ca00f;
  font-size: 54px;
  font-family: SimHei;
  font-weight: bold;
  top: 250px;
  left: 34%;
  z-index: 10;
  transform: scale(0);
}
.main_title {
  width: 100%;
  height: 24px;
  margin: 40px 0;
  font-size: 20px;
}
.line {
  background-color: #2569e6;
  width: 3px;
  height: 100%;
  float: left;
  margin-right: 20px;
}

.swiper-slide div {
  padding: 20px 20px;
}
.swiper-slide div .img {
  height: 120px;
}
</style>


// WEBPACK FOOTER //
// src/components/walkintoXinhaitong/history.vue